
import Vue from 'vue'
import TelephonyRedirectShell from '@/views/telephony/TelephonyRedirectShell.vue'
import { buildCalendarDeepLinkForMatches } from '@/utils/telephonyNavigation'
import type { TelephonyNotFoundContext } from '@/utils/telephonyMessages'
import {
  buildTelephonyRedirectViewState,
  parseTelephonySpaceId,
  phoneFromRouteQuery,
  runTelephonyLookup,
  typeFromRouteQuery,
} from '@/utils/telephonyRedirect'

export default Vue.extend({
  name: 'TelephonyActionRedirect',
  components: {
    TelephonyRedirectShell,
  },
  props: {
    spaceId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      notFoundContext: null as TelephonyNotFoundContext | null,
      errorMessage: '',
    }
  },
  async mounted() {
    await this.runRedirect()
  },
  methods: {
    async runRedirect() {
      this.loading = true
      this.notFoundContext = null
      this.errorMessage = ''

      const phone = phoneFromRouteQuery(this.$route.query)
      const outcome = await runTelephonyLookup(
        'action',
        parseTelephonySpaceId(this.spaceId),
        phone
      )
      const viewState = buildTelephonyRedirectViewState(
        outcome,
        (key) => this.$vuetify.lang.t(key)
      )
      this.loading = viewState.loading
      this.notFoundContext = viewState.notFoundContext
      this.errorMessage = viewState.errorMessage

      if (!viewState.canProceed || outcome.status !== 'success') return

      const calendarPath = buildCalendarDeepLinkForMatches(
        outcome.results,
        typeFromRouteQuery(this.$route.query),
        this.$vuetify.lang.t('$vuetify.telephony_action_title')
      )
      this.$router.replace(calendarPath)
    },
  },
})
